import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toString } from 'lodash';

import { api } from '@/api';
import { Pagination, PaginationParams } from '@/common/types';
import { API_URL, IReceiptDocumentFileDto } from '@/dtos';

import { Receipt } from '../myDocuments.types';


interface Props extends Partial<PaginationParams> {
  employeeId?: string;
}

const useGetReceiptsQuery = ({ page, perPage, searchString, employeeId }: Props) => {
  const { data, isLoading } = useQuery(
    [API_URL.DOCUMENTS_RECEIPTS_FILES, page, perPage, searchString],
    () =>
      api.get<Pagination<IReceiptDocumentFileDto>>(API_URL.DOCUMENTS_RECEIPTS_FILES, {
        params: {
          ...(searchString ? { search_value: searchString } : {}),
          page: page && page >= 0 ? page - 1 : 0,
          size: perPage || 10,
          employee_id: employeeId,
        },
      }),
    {
      retry: 0,
    }
  );

  const receipts: Receipt[] = useMemo(
    () =>
      data?.data?.content?.map((receipt) => {
        const item: Receipt = {
          id: toString(receipt?.receipt_id),
          claimId: receipt?.claim_ids?.length ? toString(receipt?.claim_ids[0]) : '',
          documentId: toString(receipt?.document_id),
          fileUrl: receipt?.file_url,
          fileName: receipt?.filename,
          providerName: receipt?.provider_name,
          createdAt: receipt?.created_at as unknown as string,
        };
        return item;
      }) || [],
    [data]
  );

  return {
    receipts,
    total: data?.data?.totalElements || 0,
    isLoading,
  };
};

export default useGetReceiptsQuery;
